<template>
  <div class="card">
    <div class="card-header">
      <span style="font-weight: bold">Pedidos pendientes
        <span v-if="self.formData.pedidos">({{ self.formData.pedidos.length }})</span></span>
      <span v-if="tipo" class="badge" style="float: right">{{ tipo }}</span>
      <field v-else name="tipo_id" widget="m2o" label="Tipo" width="200px" style="top: 5px; right: 20px"
        @change="refrescar" />
    </div>
    <div class="card-body" style="height: 230px; position: relative; overflow">
      <field ref="pedidos" name="pedidos" :structureRef="'widget_pedidos_pendientes_' + tipo" widget="handsontable"
        :height="350" :width="705" :minRows="15" style="top: 5px; left: 5px;" readonly
        :htSettings="{ columnSorting: true, beforeColumnSort: null }" class="zebraStyle" :columns="[
          {
            name: 'id',
            header: 'Acciones',
            readOnly: true,
            renderer: rendererAcciones,
            columnSorting: {
              indicator: false,
              headerAction: false,
              compareFunctionFactory: () => () => 0
            }
          },
          { name: 'ndoc', header: 'Nº' },
          { name: 'fecha', header: 'Fecha', type: 'date2' },
          {
            name: 'cliente_id',
            header: 'Cliente',
            type: 'm2o',
            primary: 'codigo',
            showCode: true,
            label: 'nombre_comercial',
          },
          {
            name: 'representante_id',
            header: 'Representante',
            type: 'm2o',
            primary: 'codigo',
            showCode: true,
            label: 'nombre',
          },
          {
            name: 'total_articulos',
            header: 'Subtotal',
            help: 'Subtotal del pedido',
            type: 'numeric',
            numericFormat: { pattern: '0,0.00' },
            sufix: ' €'
          },
          {
            name: 'total',
            header: 'Total',
            help: 'Total del pedido',
            type: 'numeric',
            numericFormat: { pattern: '0,0.00' },
            sufix: ' €'
          },
          {
            name: 'estado',
            header: 'Estado',
            type: 'select',
            options: {
              pendiente: 'Pendiente',
              proceso: 'En proceso',
              preparado: 'Preparado',
            },
            beforeRenderer(td, value) {
              td.classList.add('estado-' + value);
            },
          },
        ]" />
    </div>
  </div>
</template>
<script>
import rFormMixin from "./../components/rFormMixin.vue";
import Handsontable from "handsontable";
import Vue from "vue/dist/vue.js";
export default {
  mixins: [rFormMixin],
  props: {
    tipo: String,
  },
  data: function () {
    var self = this;
    return {
      dbAdapter: "pedido_cliente",
      mode: "new",
    };
  },
  methods: {
    rendererAcciones: function (
      instance,
      td,
      row,
      col,
      prop,
      value,
      cellProperties
    ) {
      var self = this;
      Handsontable.renderers.BaseRenderer.apply(this, arguments);
      td.classList.add("td-buttons");
      let $td = window.$(td);
      $td.empty();
      //console.log(td, instance.getSourceData()[row]);
      $td.parent().removeClass('tr-bg')
      if (instance.getSourceData()[row].id) {

        let html = `
        <div>
            <button class="button" v-tooltip="'Abrir pedido'" @click="abrirPedido"><fa-icon icon="external-link-alt" /></button>
            <button class="button" v-tooltip="'Imprimir'" @click="imprimirPedido"><fa-icon icon="print" /></button>
        </div>
        `;
        var ComponentClass = Vue.extend({
          template: html,
          methods: {
            abrirPedido(e) {
              e.preventDefault();
              e.stopPropagation();
              self.app.openWindow("pedido_cliente", {
                itemId: value,
              });
            },
            imprimirPedido(e) {
              if (!self.app.config.plantillas_documento_pedido_cliente[0]) {
                return self.app.alert("No hay plantilla de impresión configurada para pedidos de cliente.");
              }
              e.preventDefault();
              e.stopPropagation();
              const params = { id: self.app.config.plantillas_documento_pedido_cliente[0].codigo, conditions: [['id', '=', value]] };
              const url = self.app.urlGeneradorInformesDocumentoPrint;
              params.token = window.session.token;
              let ser_params = window.$.param(params);
              window.open(url + '&' + ser_params, "_blank");
            }
          },
        });
        var ins = new ComponentClass();
        ins.$mount();
        window.$(ins.$el).appendTo($td);
        //console.log(instance.getSourceData()[row])
        if (!self.tipo && instance.getSourceData()[row].tipo_id?.codigo == 'WEB') {
          $td.parent().addClass('tr-bg')
        }
      }

      return $td[0];
    },
    refrescar() {
      var self = this;
      let filter = [
        ["OR", ["estado", "=", "pendiente"], ["estado", "=", "proceso"], ["estado", "=", "preparado"]],
      ];
      if (self.tipo) filter.push(["tipo_id", "=", self.tipo]);
      else if (self.formData.tipo_id)
        filter.push(["tipo_id", "=", self.formData.tipo_id.codigo]);
      window.DB.getList("pedido_cliente", {
        filter,
        fields: [
          "ndoc",
          "fecha",
          { name: "cliente_id", fields: ["nombre_comercial"] },
          { name: "representante_id", fields: ["nombre"] },
          "total_articulos",
          "total",
          "estado",
          { name: 'tipo_id', fields: ['codigo'] }
        ],
        order: "fecha",
        orderDir: "DESC",
      }).then((res) => {
        self.$set(self.formData, "pedidos", res.data);
      });
    },
  },
  mounted() {
    var self = this;

    self.refrescar();


    window.App.$on("db-save", function (params) {
      
      if (params.model == "pedido_cliente") {
        let e = params.data.estado;
        let pedido = self.formData.pedidos.find(
          (pedido) => pedido.id == params.id
        );
        if (e == "pendiente" || e == "proceso") {
          if (pedido) {
            pedido.estado = e;
            self.$forceUpdate();
          } else {
            self.refrescar();
          }
        } else {
          self.refrescar();
        }
      }
    });

    window.App.$on("db-delete", function (params) {
      if (params.model == "pedido_cliente") {
        self.refrescar();
      }
    });

    window.App.$on('import-pedido', params => {
      self.refrescar();
    })
  },
};
</script>
<style>
td.estado-pendiente {
  background-color: #ffffbb !important;
  color: black !important;
}

td.estado-proceso {
  background-color: #aadaff !important;
  color: black !important;
}

td.estado-finalizado {
  background-color: #cec !important;
  color: black !important;
}

td.estado-cancelado {
  background-color: #ffbbbb !important;
  color: black !important;
}

td.estado-enviado {
  background-color: #e7d9ff !important;
  color: black !important;
}
</style>